import ESNAttribute from './attributes/ESNAttribute'
import ESNHiddenDataViewer from './dataViewers/ESNHiddenDataViewer'
import ESNAttributeRenderer from './renderes/ESNAttributeRenderer'

const install = ( molten ) => {
  molten.addPlugin( 'DataViewer', ESNHiddenDataViewer )
  molten.addPlugin( 'Attribute', ESNAttribute ) // Empty - To be rendered by the renderer
  molten.addPlugin( 'AttributeCellRenderer', ESNAttributeRenderer )
}

export default {
  install,
}
